import Actions from "./Actions";
import { AssignedGroupsRenderer, UserNameRenderer } from "./CustomCells";

export const getFilterMeta = (triggerRefresh, setTriggerRefresh) => ({
    fields: {
      sharedWithGroups: {
        component: AssignedGroupsRenderer,
        text: "Assigned groups",
        headProps: {
          style: {
            flex: "0 1 25%",
          },
        },
        cellProps: {
          style: {
            flex: "0 1 25%",
          },
        },
      },

        filterName: {
            text: "Filter name",
            headProps: {
                style: {
                    flex: "0 1 20%",
                },
            },
            cellProps: {
                style: {
                    flex: "0 1 20%",
                },
            },
        },
      columnSet: {
        text: "Columns set",
        headProps: {
          style: {
            flex: "0 1 20%",
          },
        },
        cellProps: {
          style: {
            flex: "0 1 20%",
          },
        },
      },
      createdBy: {
        text: "Created by",
        headProps: {
          style: {
            flex: "0 1 20%",
          },
        },
        cellProps: {
          style: {
            flex: "0 1 20%",
          },
        },
      },
        modifiedBy: {
            text: "Modified by",
            component: UserNameRenderer,
            headProps: {
                style: {
                    flex: "0 1 20%",
                },
            },
            cellProps: {
                style: {
                    flex: "0 1 20%",
                },
            },
        },
        action: {
            component: (props) => (
              <Actions {...props} triggerRefresh={triggerRefresh} setTriggerRefresh={setTriggerRefresh}/>
            ),
            headProps: {
                style: {
                    flex: "0 1 10%",
                },
            },
            cellProps: {
                style: {
                    flex: "0 1 10%",
                },
            },
        },
    },
})

export default getFilterMeta;
